module.exports = __webpack_public_path__ + "img/left-arm.178293e8.png";